var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('../lib/getFormContent'),
  getFormContent = _require.getFormContent;

/**
 * When a pair of assets are selected in the Connections section,
 * determines (in combination with the Weld Specification)
 * whether these assets are compatible
 * (i.e. whether they match a specification pair
 * in the Weld Specification section).
 *
 * @function evaluate - evaluate ucbWeldComplianceErrorTextBehavior
 */

const optionIdentifier = option => {
  if (option === undefined || option === null) {
    return undefined;
  }
  const _Object$keys = Object.keys(option),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    key = _Object$keys2[0];
  return key;
};
const matchOptions = (op1, op2) => {
  const _Object$keys3 = Object.keys(op1 || {}),
    _Object$keys4 = _slicedToArray(_Object$keys3, 1),
    k1 = _Object$keys4[0];
  const _Object$keys5 = Object.keys(op2 || {}),
    _Object$keys6 = _slicedToArray(_Object$keys5, 1),
    k2 = _Object$keys6[0];
  if (k1 === undefined || k2 === undefined) {
    return true;
  }
  const match = k1 === k2;
  return match;
};
const matchAsset = (weldSpec, asset) => {
  if (weldSpec === undefined || asset === undefined) {
    return true;
  }
  const assetType1 = weldSpec.assetType,
    diameter1 = weldSpec.diameter,
    wallThickness1 = weldSpec.wallThickness,
    coatingType1 = weldSpec.coatingType,
    grade1 = weldSpec.grade;
  const _asset$formType = asset.formType,
    _asset$formType2 = _asset$formType === void 0 ? {} : _asset$formType,
    formTypeIdentifier = _asset$formType2.identifier,
    _asset$general = asset.general,
    _asset$general2 = _asset$general === void 0 ? {} : _asset$general,
    diameter2 = _asset$general2.diameter,
    grade2 = _asset$general2.grade,
    coatingType2 = asset.coatingType,
    wallThickness2 = asset.wallThickness;
  const assetType2 = {
    [formTypeIdentifier]: {}
  };
  return matchOptions(assetType1, assetType2) && matchOptions(diameter1, diameter2) && matchOptions(wallThickness1, wallThickness2) && matchOptions(coatingType1, coatingType2) && matchOptions(grade1, grade2);
};
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const formContentEvaluator = option => getFormContent(optionIdentifier(option), content, parentContentPath, transientContext, nativeFunctions);
  const _content$general = content.general,
    _content$general2 = _content$general === void 0 ? {} : _content$general,
    weldSpecification = _content$general2.weldSpecification,
    _content$aheadAsset = content.aheadAsset,
    _content$aheadAsset2 = _content$aheadAsset === void 0 ? {} : _content$aheadAsset,
    aheadAsset = _content$aheadAsset2.asset,
    _content$behindAsset = content.behindAsset,
    _content$behindAsset2 = _content$behindAsset === void 0 ? {} : _content$behindAsset,
    behindAsset = _content$behindAsset2.asset;
  if (aheadAsset === undefined || behindAsset === undefined) {
    return undefined;
  }
  const weldSpecificationContent = await formContentEvaluator(weldSpecification);
  const aheadAssetContent = await formContentEvaluator(aheadAsset);
  const behindAssetContent = await formContentEvaluator(behindAsset);
  const _Object$keys7 = Object.keys(aheadAsset),
    _Object$keys8 = _slicedToArray(_Object$keys7, 1),
    aheadID = _Object$keys8[0];
  const _Object$keys9 = Object.keys(behindAsset),
    _Object$keys0 = _slicedToArray(_Object$keys9, 1),
    behindID = _Object$keys0[0];
  if (aheadID === behindID) {
    return "".concat(aheadAssetContent.title, " cannot be connected to itself.");
  }
  if (weldSpecification === undefined) {
    return undefined;
  }
  const _weldSpecificationCon = weldSpecificationContent.general,
    _weldSpecificationCon2 = _weldSpecificationCon === void 0 ? {} : _weldSpecificationCon,
    _weldSpecificationCon3 = _weldSpecificationCon2.specificationsAssetCollection,
    specificationsAssetCollection = _weldSpecificationCon3 === void 0 ? {} : _weldSpecificationCon3;
  const keys = Object.keys(specificationsAssetCollection);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const value = specificationsAssetCollection[key];
    const assetOne = value.assetOne,
      assetTwo = value.assetTwo;
    const match1a = matchAsset(assetOne, aheadAssetContent);
    const match2b = matchAsset(assetTwo, behindAssetContent);
    const match1b = matchAsset(assetOne, behindAssetContent);
    const match2a = matchAsset(assetTwo, aheadAssetContent);
    const match = match1a && match2b || match2a && match1b;
    if (match) {
      return undefined;
    }
  }
  return "".concat(aheadAssetContent.title, " cannot be connected") + " to ".concat(behindAssetContent.title, " per") + " Weld Specification ".concat(weldSpecificationContent.title, ".");
};
module.exports = {
  evaluate
};